import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';

export default function AdminLayout() {
    const navigate = useNavigate();
    const handleLogout = () => {
        localStorage.removeItem('skillmatch_token');
        navigate('/login');
    };

    return (
        <div className="flex h-screen bg-gray-100 font-sans">
            {/* Sidebar */}
            <aside className="w-64 bg-slate-900 text-white flex flex-col">
                <div className="p-6 text-center border-b border-slate-700">
                    <h1 className="text-2xl font-bold text-blue-400">SkillMatch <span className="text-white text-xs bg-red-600 px-2 py-1 rounded">ADMIN</span></h1>
                </div>
                <nav className="flex-1 p-4 space-y-2">
                    <Link to="/admin/dashboard" className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition"><span className="material-symbols-outlined">dashboard</span> Dashboard</Link>
                    <Link to="/admin/candidates" className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition"><span className="material-symbols-outlined">group</span> Ứng viên</Link>
                    <Link to="/admin/businesses" className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition"><span className="material-symbols-outlined">business</span> Doanh nghiệp</Link>
                    <Link to="/admin/jobs" className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition"><span className="material-symbols-outlined">work</span> Tin tuyển dụng</Link>
                    <Link to="/admin/feedbacks" className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition"><span className="material-symbols-outlined">feedback</span> Phản hồi</Link>
                    <Link to="/admin/blogs" className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition"><span className="material-symbols-outlined">article</span> Quản lý Blog</Link>
                    <Link to="/admin/payments" className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition"><span className="material-symbols-outlined">payments</span> Thanh toán</Link>
                <Link to="/admin/about-settings" className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition"><span className="material-symbols-outlined">web</span> Cài đặt trang About</Link>
                </nav>
                <div className="p-4 border-t border-slate-700">
                    <button onClick={handleLogout} className="flex items-center gap-2 text-red-400 hover:text-red-300 w-full px-4"><span className="material-symbols-outlined">logout</span> Đăng xuất</button>
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-1 overflow-y-auto p-8">
                <Outlet />
            </main>
        </div>
    );
}